// extracted by mini-css-extract-plugin
export var details = "_fd-0";
export var inspectorPopover = "_fd-1";